import React, { useState } from "react";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { ChevronDown } from "lucide-react";

export default function IndemnityBlock({
  checked,
  onCheckedChange,
  signature,
  onSignatureChange,
  idPrefix = "indemnity",
}) {
  const [open, setOpen] = useState(false);
  return (
    <div
      data-testid={`${idPrefix}-indemnity-block`}
      className="border border-white/10 bg-black/40 p-6"
    >
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37] font-bold">
            Digital Indemnity Waiver
          </div>
          <div className="mt-1 text-sm text-white/60">
            Required · read and sign to proceed.
          </div>
        </div>
        <button
          type="button"
          data-testid={`${idPrefix}-indemnity-toggle`}
          onClick={() => setOpen((o) => !o)}
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/70 hover:text-[#d4af37]"
        >
          {open ? "Hide" : "Read"} Waiver
          <ChevronDown
            size={14}
            className={`transition-transform ${open ? "rotate-180" : ""}`}
          />
        </button>
      </div>

      {open && (
        <div className="mt-5 text-[13px] text-white/70 leading-relaxed space-y-3 max-h-64 overflow-y-auto pr-2 border-t border-white/10 pt-4">
          <p>
            <strong className="text-white">1. Assumption of Risk.</strong> I
            acknowledge that Mixed Martial Arts training — including striking,
            grappling, sparring and conditioning — involves physical risk,
            including the possibility of bruises, sprains, fractures, concussion
            and other injury.
          </p>
          <p>
            <strong className="text-white">2. Release of Liability.</strong> I
            release Full Circle MMA, its owners, coaches, staff, affiliates and
            training partners from claims arising out of my participation,
            except to the extent caused by negligence.
          </p>
          <p>
            <strong className="text-white">3. Medical Fitness.</strong> I confirm
            I am medically fit to train. I will disclose any pre-existing
            injuries or conditions to my coach and stop immediately if I feel
            unwell.
          </p>
          <p>
            <strong className="text-white">4. Code of Conduct.</strong> I agree
            to train with respect, control and honesty. Ego-driven behaviour or
            harassment will result in removal from the gym.
          </p>
          <p>
            <strong className="text-white">5. Consent.</strong> By ticking the
            box and typing my full name below, I electronically sign this waiver
            and acknowledge it is legally binding.
          </p>
        </div>
      )}

      <div className="mt-6 flex items-start gap-3">
        <Checkbox
          id={`${idPrefix}-indemnity-agree`}
          data-testid={`${idPrefix}-indemnity-checkbox`}
          checked={checked}
          onCheckedChange={onCheckedChange}
          className="mt-1 border-white/30 data-[state=checked]:bg-[#d4af37] data-[state=checked]:border-[#d4af37] data-[state=checked]:text-black rounded-none"
        />
        <Label
          htmlFor={`${idPrefix}-indemnity-agree`}
          className="text-sm text-white/80 leading-relaxed cursor-pointer"
        >
          I have read and agree to the Digital Indemnity Waiver above. I
          understand the risks and accept them.
        </Label>
      </div>

      <div className="mt-5">
        <Label
          htmlFor={`${idPrefix}-indemnity-signature`}
          className="text-xs uppercase tracking-[0.2em] text-white/60"
        >
          Electronic Signature (type full name)
        </Label>
        <Input
          id={`${idPrefix}-indemnity-signature`}
          data-testid={`${idPrefix}-indemnity-signature`}
          value={signature}
          onChange={(e) => onSignatureChange(e.target.value)}
          placeholder="e.g. John Citizen"
          className="mt-2 bg-transparent border-white/15 rounded-none h-12 font-heading text-xl tracking-wide focus-visible:ring-[#d4af37]"
        />
      </div>
    </div>
  );
}
